export const countFocusKeyword = (content, keywords) => {
  const regex = new RegExp(`\\b(?:${keywords.join("|")})\\b`, "gi");
  const matches = content?.match(regex) || [];
  return matches.length;
};
export const countFocusKeywordAddon = (content, keywords) => {
  console.log(content, keywords);
  let totalCount = 0;
  if (keywords) {
    keywords.forEach(keyword => {
      const regex = new RegExp(`\\b${keyword}\\b`, "gi");
      const matches = content.match(regex) || [];
      totalCount += matches.length;
    });
  }
  return totalCount;
};
